import { transparentize } from 'polished'
import {
  isArtboardElementType,
  isGroupElementType,
  ElementType,
} from '../../../../../../../inspector'
import styled, { css } from 'styled-components'

export const ElementIcon = styled.div<{ $isSymbol?: boolean }>`
  position: relative;

  display: flex;
  justify-content: center;
  align-items: center;
  flex: none;

  width: 36px;
  height: 36px;

  background-color: ${({ theme }) => theme.colors.background.tertiary.C};
  border-radius: 4px;

  margin-right: 12px;

  ${({ theme, $isSymbol }) =>
    $isSymbol &&
    css`
      background-color: ${transparentize(0.9, theme.colors.inspect.symbol.A)};
    `}
`

export const Icon = styled.svg<{ $isSymbol?: boolean }>`
  color: ${({ theme }) => theme.colors.foreground.secondary.D};

  ${({ theme, $isSymbol }) =>
    $isSymbol &&
    css`
      color: ${theme.colors.inspect.symbol.A};
    `}
`

// Some icons need an extra space for the exportable icon (the knife icon)
const isNeededExtraSpaceForExportableIcon = (
  elementType: ElementType
): boolean =>
  isArtboardElementType(elementType) ||
  elementType === 'text' ||
  isGroupElementType(elementType)

/**
 * STYLES
 */
export const ExportableIconWrapper = styled.div<{
  elementType: ElementType
}>`
  width: 21px;
  height: 21px;
  position: absolute;
  transform: ${({ elementType }) =>
    isNeededExtraSpaceForExportableIcon(elementType)
      ? 'translate(2px, 1px)'
      : undefined};
`
